export class RoblexCollapsedSidepanelConfig<D = any> {
    backdrop?: boolean;
    className?: string;
    data?: D;
}
